import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type EmptyKeyConfirmDialogProps = {
  overlay: OverlayState
  onConfirm: () => void
}

/**
 * Gates saving a config whose grouping key is empty — every line item on a
 * matching document would merge into one. A one-click confirm, not a
 * type-the-name guard: the config remains fully editable afterward, unlike
 * a delete.
 */
export default function EmptyKeyConfirmDialog({
  overlay,
  onConfirm,
}: EmptyKeyConfirmDialogProps) {
  return (
    <Dialog {...overlay} title="Save with an empty grouping key?">
      <DialogContent>
        <Typography>
          With no fields kept in the grouping key, every line item on a matching
          document will be merged into one on export. This can still be changed
          later by adding a field back to the key.
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm()
            overlay.close()
          }}
        >
          Save anyway
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
